module.exports = __webpack_public_path__ + "static/img/4.7f344ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Empresariales-Multirriesgo-Copropiedades/4.png
// module id = dybp
// module chunks = 0